module.exports = __webpack_public_path__ + "img/9_79.fe6eae2d.png";